var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "write-message-container" }, [
    _c("div", { staticClass: "card-image-container" }, [
      _c("img", {
        staticClass: "lazyload",
        attrs: {
          width: "280",
          height: "280",
          loading: "lazy",
          src: _vm._f("getProductImage")(_vm.selectedCard)
        }
      }),
      _vm._v(" "),
      _c("div", [
        _vm.selectedCard.images.length > 1
          ? _c("div", { staticClass: "card-secondary-images w-100 m-t-1rem" }, [
              _c("img", {
                staticClass: "w-25 h-auto",
                attrs: {
                  width: "20",
                  height: "20",
                  src: _vm.selectedCard.images[1].src
                }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass:
              "blue-span color-link underline  flex flex-align-center flex-justify-between gap-05vw",
            on: { click: _vm.closeCard }
          },
          [
            _c("img", {
              staticClass: "h-auto",
              attrs: {
                width: "15px",
                height: "10px",
                src:
                  "https://cdn.shopify.com/s/files/1/1363/8433/files/edit.svg?v=1749479131"
              }
            }),
            _vm._v("\r\n                Change Card\r\n            ")
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "write-container",
        class: _vm.isBlankMessage ? "blank" : ""
      },
      [
        _c("div", [
          _c("p", { staticClass: "body-header-4 font-bold" }, [
            _vm._v("Type in your message below.")
          ]),
          _vm._v(" "),
          _vm.selectedCard.id != 7148612419749
            ? _c(
                "p",
                {
                  staticClass: "body-base color-lightpurple lh-default m-b-1rem"
                },
                [
                  _vm._v(
                    "One of our team members will hand write your message "
                  ),
                  _c("br"),
                  _vm._v(" and pack it in with your box.")
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.remainingCharacters < 0
            ? _c("p", { staticClass: "red-span" }, [
                _vm._v(
                  "Your message has a limit of 200 characters. Keep it short and sweet!"
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedCard.id != 7148612419749
            ? _c(
                "div",
                {
                  staticClass:
                    "blank-card-container flex flex-align-center gap-05vw m-b-1rem"
                },
                [
                  _c("input", {
                    attrs: { id: "blankCard", type: "checkbox" },
                    domProps: { checked: _vm.isBlankMessage },
                    on: {
                      change: function($event) {
                        return _vm.changeBlankMessage()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass:
                        "body-base color-link body-base underline  flex flex-align-center gap-05vw",
                      attrs: { for: "blankCard" }
                    },
                    [_vm._v("Leave the card blank")]
                  )
                ]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-container" }, [
          !_vm.isBlankMessage
            ? _c("div", { staticClass: "message-container w-100 m-b-1rem" }, [
                _c(
                  "label",
                  {
                    class: _vm.showCardAlert ? "red" : "",
                    attrs: { for: "message" }
                  },
                  [_vm._v("Your Message:")]
                ),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.message,
                      expression: "message"
                    }
                  ],
                  staticClass: "w-100",
                  attrs: {
                    placeholder: "Start typing here...",
                    maxlength: "200",
                    cols: "30",
                    rows: "3",
                    id: "message"
                  },
                  domProps: { value: _vm.message },
                  on: {
                    change: function($event) {
                      return _vm.changeMessage()
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.message = $event.target.value
                    }
                  }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "w-100 flex flex-align-center flex-justify-between"
            },
            [
              !_vm.isBlankMessage
                ? _c("div", { staticClass: "from-container" }, [
                    _c(
                      "label",
                      {
                        class: _vm.showCardAlert ? "red" : "",
                        attrs: { for: "from" }
                      },
                      [_vm._v("From:")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.from,
                          expression: "from"
                        }
                      ],
                      attrs: {
                        placeholder: "Your Name",
                        maxlength: "200",
                        id: "from",
                        type: "text"
                      },
                      domProps: { value: _vm.from },
                      on: {
                        change: function($event) {
                          return _vm.changeFrom()
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.from = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "purple-span",
                        class: _vm.remainingCharacters == 0 ? "red" : ""
                      },
                      [
                        _vm._v(
                          "Character Remaining " +
                            _vm._s(_vm.remainingCharacters)
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "hb-btn primary",
                  class: _vm.isLoading ? "isLoading" : "",
                  on: {
                    click: function($event) {
                      return _vm.openCart()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.buttonText))]
              )
            ]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }